<template>
  <div class="wrap">
    <div class="wrap-box  theme-color">
      <el-table :data="tableData" style="margin-top:15px;" height="620" empty-text="该表格暂无页面数据" border :header-cell-style="tableHeaderColor">
        <el-table-column prop="id" label="合同编号" align="center" width="100"></el-table-column>
        <el-table-column prop="signingTime" label="签订时间" align="center"></el-table-column>
        <el-table-column prop="propertyCompanyName" label="物业" align="center"></el-table-column>
        <el-table-column prop="startTime" label="合同开始时间" align="center"></el-table-column>
        <el-table-column prop="endTime" label="合同结束时间" align="center"></el-table-column>
        <el-table-column prop="status" label="合同状态" align="center">
            <template slot-scope="scope">
            {{contractState[scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column prop="statusModifyingTime" label="合同状态变更时间" align="center">
         
        </el-table-column>
        <el-table-column label="自动付款" align="center">
          <template slot-scope="scope">
            <div @click="unSetAutoPay(scope.row)" class="ts" v-if="scope.row.isauto">
              取消自动付款
            </div>
            <div @click="setAutoPay(scope.row)" class="ts" v-else>
              设置自动付款
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 生成引用链接 -->
      <el-dialog title="生成引用链接" :visible.sync="isShow" :close-on-click-modal="false" width="400px">
        <el-form ref="form" label-width="90px" class="cldCarForm">
          <el-form-item label="链接" class="form-item">
            <span class="ztWrap">{{ urlBase }}</span>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="copy(urlBase)" class="updatabuttom">复制</el-button>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as utils from "@/utils/index.js";
import config from "@common/config/index.js"
export default {
  data () {
    return {
      contractState:config.contractState,
      pageName: "",
      pagePath: "", //页面路径
      tableData: [],
      pageDig: true,
      //分页栏
      page: {
        pageSizes: [10, 20, 50, 100, 500, 1000], //每页显示条目个数
        size: 10,
        pageIndex: 1,
        total: 0
      },
      layout: "total,  prev, pager, next,sizes",
      title: "新增",
      form: {
        pageName: "",
        pagePath: "",
        loginPsd: ""
      },
      rules: {
        pageName: [
          {
            required: true,
            message: "页面名称不能为空",
            trigger: ["blur", "change"]
          }
        ],
        pagePath: [
          {
            required: true,
            message: "页面路径不能为空",
            trigger: ["blur", "change"]
          }
        ],
        loginPsd: [
          {
            required: true,
            message: "登录密码不能为空",
            trigger: ["blur", "change"]
          }
        ]
      },
      isShow: false,
      urlBase: "",
      oldTable: [],
      ifAdd: false,
      subsystems: []
    };
  },
  created () {
    this.getData();
  },
  mounted () { },
  methods: {
    setAutoPay (row) {
      this.$api.rentalArea
        .setRentalAreaTrusteeshipBillAutoPaymentForProperty(0,row.id)
        .then(res => {
          if (res.success) {
            this.$message.success("设置成功");
            row.isauto = true
          }
        });
    },
    unSetAutoPay (row) {
      this.$api.rentalArea
        .unsetRentalAreaTrusteeshipBillAutoPaymentForProperty (0,row.id)
        .then(res => {
          if (res.success) {
            this.$message.success("取消成功");
            row.isauto = false
            // this.getData();
          }
        });
    },
    //查询页面
    getData () {
      let vm = this;
      // 获所有合同的信息
      const apiArr = [vm.$api.rentalArea.getRentalAreaTrusteeshipContractForProperty(0,null,null,null,null,null,-1), vm.$api.rentalArea.listRentalAreaTrusteeshipContractOfBillAutoPaymentForProperty(0)]
      Promise.all(apiArr).then(resArr => {
        let tableData = []
        if (resArr[0].success && resArr[0].data) {
          tableData = resArr[0].data
          let billTable = []
          if (resArr[1].success && resArr[1].data) {
            billTable = resArr[1].data
          }

          for (let i = 0; i < tableData.length; i++) {
            const isHave = billTable.find(c => c.id === tableData[i].id)
            let isauto = false
            if (isHave) {
              isauto = true
            }

            tableData[i].isauto = isauto
          }
        }
        vm.tableData = tableData
        console.log(tableData)
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  color: #000000;
  .wrap-box {
    padding: 10px;
    box-sizing: border-box;
    // height: 100%;
    width: 100%;
    .carForm {
      display: flex;
      .form-item {
        width: 300px;
        .form-input {
          width: 200px !important;
        }
      }
      .form-buttom {
        height: 33px;
      }
    }
    .cldCarForm {
      .form-item {
        width: 300px;
        .form-input {
          width: 200px;
        }
      }
      .form-buttom {
        height: 33px;
      }
    }
  }
}
.pageNew {
  text-align: right;
  padding: 14px 0px 0px 0px;
}
.nc ::v-deep .el-input {
  width: 197px !important;
}
.ztWrap {
  overflow: hidden;
  white-space: normal;
}
.flexbox {
  display: flex;
}
.ts {
  color: dodgerblue;
  cursor: pointer;
}
::v-deep .el-table th, .theme-defalt .table-warp .el-table tr {
    background-color: #f0f3f4;
        color: #2a2b2c;
        font-weight: 600;
}
</style>
